<template>
	
	<div id="wqa-footer" class="wqa-design" v-once>
		<footer id="footer" class="footer">
			<div class="footer__social" style="margin: 0px 0px;">
			<!-- <div class="footer__social" style="margin: 0px 68px;"> -->
				<div class="container">
					<div class="row">
						<div class="col-sm-12">
							<div class="footer__social__container">
								<form class="footer__subscribe-form subscribe-form">
									<!-- FooterNewsletterForm -->
									<!-- End FooterNewsletterForm -->
								</form>
								<div class="footer__social-icons">
									<ul class="social-icons">
										<!-- FooterSocialLinksSlot -->
										<li class="social-icons__item">
											<a href="#" class="social-icons__link">
												<img loading="lazy" src="~@/assets/medias/instagram.png"
													title="Instagram" alt="Instagram">
											</a>
										</li>
										<li class="social-icons__item">
											<a href="#" class="social-icons__link">
												<img loading="lazy" src="~@/assets/medias/facebook.png"
													title="Facebook" alt="Facebook">
											</a>
										</li>
										<li class="social-icons__item">
											<a href="#" class="social-icons__link">
												<img loading="lazy" src="~@/assets/medias/youtube.png"
													title="YouTube" alt="YouTube">
											</a>
										</li>
										<li class="social-icons__item">
											<a href="#" class="social-icons__link">
												<img loading="lazy" src="~@/assets/medias/linkedin.webp"
													title="LinkedIn" alt="LinkedIn">
											</a>
										</li>

										<!-- End FooterSocialLinksSlot -->
									</ul>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="footer__cta">
				<div class="container">
					<!-- <div class="row" style="margin: 0px 68px;"> -->
					<div class="row">
						<div class="col-sm-12">
								<router-link to="/find-an-advisor" class="btn btn-primary"
								target="_self">Find an Advisor</router-link>
								<router-link to="/contact-us" class="btn btn-invert"
								target="_self">Contact Modiway</router-link><!-- End FooterButtonLinks -->
						</div>
					</div>
				</div>
			</div>
			<div class="footer__links">
				<div class="container">
					<div class="row">
						<div class="col-sm-12">
							<div class="footer__links__groups">
								<!-- FooterNavLinks1 -->
								<div class="footer__links__group">
									<h6 class="footer__links__heading">Contact Us</h6>
									<ul class="footer__links__list">
										<li class="footer__links__list__item">
											<a class="" target="_self">Modiway</a>
										</li>
										<li class="footer__links__list__item">
											<a class="" target="_self">Community
												Center,</a>
										</li>
										<li class="footer__links__list__item">
											<a class="" target="_self">New Friends
												Colony,</a>
										</li>
										<li class="footer__links__list__item">
											<a class="" target="_self">New Delhi, Pin
												- 110025</a>
										</li>
										<li class="footer__links__list__item">
											<a class="" target="_self">Contact Center:
												0124-6572300</a>
										</li>
										<li class="footer__links__list__item">
											<a class="">Email: <a
													href="mailto:india@Modiway.com">support@modiway.com</a></a>
										</li>
									</ul>
								</div>
								<!-- End FooterNavLinks1 -->
								<!-- FooterNavLinks2 -->
								<div class="footer__links__group">
									<h6 class="footer__links__heading">Company</h6>
									<ul class="footer__links__list">
										<li class="footer__links__list__item">
											<RouterLink to="/our-story" style="color: #354657;text-decoration: none;transition: none;">
													Our Story
											</RouterLink>
										</li>
										<li class="footer__links__list__item">
											<RouterLink class="footer__links__list__link" :to="'/blogs'" target="_self">Blogs</RouterLink>
										</li>
										<li class="footer__links__list__item">
											<RouterLink class="footer__links__list__link" :to="'/faq'" target="_self">FAQs</RouterLink>
										</li>
										<!-- <li class="footer__links__list__item">
											<a class="footer__links__list__link gaCrossDomain" href="#"
												target="_blank">News</a>
										</li> -->
									</ul>
								</div>
								<!-- End FooterNavLinks2 -->
								<!-- FooterNavLinks3 -->
								<!-- <div class="footer__links__group">
									<h6 class="footer__links__heading">Quick Links</h6>
									<ul class="footer__links__list">
										<li class="footer__links__list__item">
											<a class="footer__links__list__link" href="#" target="_self">Empowered
												Success</a>
										</li>
										<li class="footer__links__list__item">
											<a class="footer__links__list__link" href="#" target="_blank">Silver
												Club</a>
										</li>
										<li class="footer__links__list__item">
											<a class="footer__links__list__link" href="#" target="_self">Why
												Modiway?</a>
										</li>
									</ul>
								</div> -->
								<!-- End FooterNavLinks3 -->
								<!-- FooterNavLinks4 -->
								<div class="footer__links__group" style="display: none;">
									<h6 class="footer__links__heading">Language</h6>
									<ul class="footer__links__list">
										<li class="footer__links__list__item">
											<a class="footer__links__list__link" target="_self">Information in
												English</a>
										</li>
										<li class="footer__links__list__item">
											<a class="footer__links__list__link" target="_self">Information in
												Hindi</a>
										</li>
										<li class="footer__links__list__item">
											<a class="footer__links__list__link" target="_self">Information in
												Tamil</a>
										</li>
									</ul>
								</div>
								<!-- End FooterNavLinks4 -->
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="footer__sub-footer">
				<div class="container">
					<div class="row">
						<div class="col-sm-12">
							<div class="footer__sub-footer__container">
								<div class="footer__sub-footer__copyright">
									<img class="footer__sub-footer__copyright__logo"> Modiway &copy; 2024
								</div>
								<ul class="footer__sub-footer__links">
									<!-- FooterLinks -->
									<li class="footer__sub-footer__links__item ">
										<RouterLink class="footer__sub-footer__links____link" to="/privacy-notice">Privacy
											Notice</RouterLink>
									</li>
									<li class="footer__sub-footer__links__item ">
										<RouterLink class="footer__sub-footer__links____link" to="/terms-to-use">Website
											Terms of Use</RouterLink>
									</li>
									<li class="footer__sub-footer__links__item ">
										<RouterLink class="footer__sub-footer__links____link" to="/direct-seller-lookup"
											target="_self">Direct Seller Lookup</RouterLink>
									</li>
									<!-- End FooterLinks -->
								</ul>
								<div class="footer__sub-footer-language">
									<div class="dropdown dropdown--lang dropdown--lang-white btn-group dropup">
										<button class="btn dropdown-toggle" type="button" id="dropdownMenuButton"
											data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"
											data-display="static">
											India - English</button>
										<!-- <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
										<div class="dropdown-body">
											<a class="dropdown-item" href="#">India</a>
											</div>
										<div class="dropdown-footer ml-4 mr-4">
											<a class="dropdown-item" href="#" data-js-language-selector="">
												<span class="icon--globe"></span>
												Change Region</a>
										</div>
									</div> -->
									</div>
								</div>
							</div>
							<div id="teconsent"></div>
						</div>
					</div>
				</div>
			</div>
		</footer>
	</div>

</template>

<script>
export default {
	name: "app-footer",
};
</script>

<style scoped>
@media (max-width:768px){
.footer__sub-footer__container{
	margin-top:-30px;
}
.wqa-design .footer__links__groups {
	display: flex;
    flex-wrap: wrap;
    padding: 30px 15px 0px 15px;
}
}
.wqa-design .hero__footer {
   margin-bottom: 50px;
}
footer {
	text-align: center;
	/* padding: 20px; */
	background-color:white !important;
	
	width: 100%;
	bottom: 0;
}
.footer__links__heading,.footer__sub-footer__container{font-size: 14px;}
.footer__links__list__item{font-size: 14.4px;}
.footer__links__groups{text-align: left;}
.wqa-design .btn{font-size: 16px;}
</style>